if (!customElements.get('dl-product-bundles-list-m')) {
  customElements.define(
    'dl-product-bundles-list-m',
    class extends HTMLElement {
      connectedCallback() {
        this.viewport = this.querySelector('[data-bundles-viewport]');
        this.previousButton = this.querySelector('[data-bundles-previous]');
        this.nextButton = this.querySelector('[data-bundles-next]');
        if (!this.viewport || !this.previousButton || !this.nextButton) return;

        this.handlePreviousClick = () => this.move(-1);
        this.handleNextClick = () => this.move(1);
        this.handleScroll = () => this.scheduleButtonUpdate();
        this.handleResize = () => {
          this.cancelScrollAnimation();
          this.updateMetrics();
          this.updateButtons();
        };
        this.handleManualScrollStart = () => this.cancelScrollAnimation();

        this.previousButton.addEventListener('click', this.handlePreviousClick);
        this.nextButton.addEventListener('click', this.handleNextClick);
        this.viewport.addEventListener('scroll', this.handleScroll, { passive: true });
        this.viewport.addEventListener('wheel', this.handleManualScrollStart, { passive: true });
        this.viewport.addEventListener('touchstart', this.handleManualScrollStart, { passive: true });
        this.viewport.addEventListener('pointerdown', this.handleManualScrollStart, { passive: true });
        window.addEventListener('resize', this.handleResize);
        this.updateMetrics();
        this.updateButtons();
      }

      disconnectedCallback() {
        if (!this.viewport || !this.previousButton || !this.nextButton) return;

        this.previousButton.removeEventListener('click', this.handlePreviousClick);
        this.nextButton.removeEventListener('click', this.handleNextClick);
        this.viewport.removeEventListener('scroll', this.handleScroll);
        this.viewport.removeEventListener('wheel', this.handleManualScrollStart);
        this.viewport.removeEventListener('touchstart', this.handleManualScrollStart);
        this.viewport.removeEventListener('pointerdown', this.handleManualScrollStart);
        window.removeEventListener('resize', this.handleResize);
        this.cancelScrollAnimation();
        window.cancelAnimationFrame(this.buttonUpdateFrame);
      }

      move(direction) {
        const item = this.querySelector('.dl-product-bundles-list-m__item');
        if (!item) return;

        const track = item.parentElement;
        const gap = parseFloat(window.getComputedStyle(track).columnGap) || 0;
        const distance = item.getBoundingClientRect().width + gap;
        const startPosition = this.viewport.scrollLeft;
        const basePosition = Number.isFinite(this.targetScrollLeft) ? this.targetScrollLeft : startPosition;
        const targetPosition = Math.min(Math.max(basePosition + direction * distance, 0), this.maxScroll);

        this.cancelScrollAnimation(false);
        this.targetScrollLeft = targetPosition;

        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          this.viewport.scrollLeft = targetPosition;
          this.targetScrollLeft = null;
          this.updateButtons();
          return;
        }

        const duration = 420;
        const startTime = performance.now();
        const scrollDistance = targetPosition - startPosition;

        const animate = (currentTime) => {
          const progress = Math.min((currentTime - startTime) / duration, 1);
          const easedProgress = 1 - Math.pow(1 - progress, 3);
          this.viewport.scrollLeft = startPosition + scrollDistance * easedProgress;

          if (progress < 1) {
            this.scrollAnimationFrame = window.requestAnimationFrame(animate);
            return;
          }

          this.viewport.scrollLeft = targetPosition;
          this.scrollAnimationFrame = null;
          this.targetScrollLeft = null;
          this.updateButtons();
        };

        this.scrollAnimationFrame = window.requestAnimationFrame(animate);
      }

      cancelScrollAnimation(resetTarget = true) {
        if (this.scrollAnimationFrame) {
          window.cancelAnimationFrame(this.scrollAnimationFrame);
          this.scrollAnimationFrame = null;
        }

        if (resetTarget) this.targetScrollLeft = null;
      }

      scheduleButtonUpdate() {
        if (this.buttonUpdateFrame) return;

        this.buttonUpdateFrame = window.requestAnimationFrame(() => {
          this.buttonUpdateFrame = null;
          this.updateButtons();
        });
      }

      updateMetrics() {
        this.maxScroll = Math.max(this.viewport.scrollWidth - this.viewport.clientWidth, 0);
      }

      updateButtons() {
        const isAtBeginning = this.viewport.scrollLeft <= 1;
        const isAtEnd = this.viewport.scrollLeft >= this.maxScroll - 1;

        if (this.previousButton.disabled !== isAtBeginning) {
          this.previousButton.disabled = isAtBeginning;
        }

        if (this.nextButton.disabled !== isAtEnd) {
          this.nextButton.disabled = isAtEnd;
        }
      }
    }
  );
}
